// extracted by mini-css-extract-plugin
export var cardIcon = "_60-5";
export var cardIconUnframed = "_60-9";
export var checkboxCard = "_60-0";
export var checkboxCardSelected = "_60-4";
export var disabled = "_60-2";
export var interactive = "_60-1";
export var outerBorder = "_60-3";
export var spacerMedium = "_60-8";
export var spacerSmall = "_60-7";
export var spacerXsmall = "_60-6";